import { Box, TextField } from "@mui/material";
import SectionCollapsible from "../../../../common/SectionCollapsible";
import { useFormikContext } from "formik";
import { AddSolutionFormValues } from "../../../add/form/types";
import { EditSolutionFormValues } from "../../../edit/form/types";

export function WebsiteUrlField() {
  const context = useFormikContext<
    AddSolutionFormValues | EditSolutionFormValues
  >();

  return (
    <TextField
      id="solution-internal-details-website-url"
      label="Earthly.org page url"
      variant="standard"
      fullWidth
      sx={{ paddingBottom: 2 }}
      autoComplete="disabled"
      onChange={(event) =>
        context.setFieldValue(
          "internal-details.website-url",
          (event.target as HTMLInputElement).value,
        )
      }
      value={context.values["internal-details"]["website-url"]}
      error={
        context.touched["internal-details"]?.["website-url"] &&
        Boolean(context.errors["internal-details"]?.["website-url"])
      }
      onBlur={context.handleBlur}
      helperText={
        context.touched["internal-details"]?.["website-url"] &&
        context.errors["internal-details"]?.["website-url"]
      }
    />
  );
}

function InternalDetailsContainer({ open }: { open: boolean }) {
  const context = useFormikContext<
    AddSolutionFormValues | EditSolutionFormValues
  >();

  return (
    <>
      <SectionCollapsible open={open} label="Internal Details">
        <Box data-testid="internal-details-section-collapsible">
          <WebsiteUrlField />
          <TextField
            id="solution-internal-details-xero-account-number"
            label="Xero Account Number"
            variant="standard"
            fullWidth
            sx={{ paddingBottom: 2 }}
            autoComplete="disabled"
            onChange={(event) =>
              context.setFieldValue(
                "internal-details.xero-account-number",
                (event.target as HTMLInputElement).value,
              )
            }
            value={context.values["internal-details"]["xero-account-number"]}
            error={Boolean(
              context.errors["internal-details"]?.["xero-account-number"],
            )}
            helperText={
              context.errors["internal-details"]?.["xero-account-number"]
            }
          />
          <TextField
            id="solution-internal-details-additional-resource-link"
            label="Additional Resource Link"
            variant="standard"
            fullWidth
            sx={{ paddingBottom: 2 }}
            autoComplete="disabled"
            onChange={(event) =>
              context.setFieldValue(
                "internal-details.additional-resources-link",
                (event.target as HTMLInputElement).value,
              )
            }
            value={
              context.values["internal-details"]["additional-resources-link"]
            }
            error={Boolean(
              context.errors["internal-details"]?.["additional-resources-link"],
            )}
            helperText={
              context.errors["internal-details"]?.["additional-resources-link"]
            }
          />
          <TextField
            inputProps={{ "aria-label": "Research Team Notes" }}
            id="solution-internal-details-notes"
            label="Research Team Notes"
            variant="standard"
            rows={4}
            multiline
            fullWidth
            sx={{ paddingBottom: 2 }}
            autoComplete="disabled"
            onChange={(event) =>
              context.setFieldValue(
                "internal-details.research-team-notes",
                (event.target as HTMLInputElement).value,
              )
            }
            value={context.values["internal-details"]["research-team-notes"]}
          />
        </Box>
      </SectionCollapsible>
    </>
  );
}

export default InternalDetailsContainer;
